import Tab from "@mui/material/Tab"
import Tabs from "@mui/material/Tabs"
import { Link as RouterLink, useLocation } from "react-router-dom"

import { findActiveTabbedNavItem, isNavItemActive } from "../adminNavConfig"

/*
 * Tab strip linking sibling admin pages that share one sidebar entry
 * (e.g. Email / SMS templates). Each tab is a real link to the page's
 * original URL; renders nothing on pages without siblings.
 */
export default function AdminSectionTabs() {
  const location = useLocation()
  const item = findActiveTabbedNavItem(location.pathname)
  // Only on the tabbed pages themselves, not on detail pages beneath them
  // (e.g. /admin/concierges/:id keeps its own layout).
  const activeTab = item?.tabs.find((tab) =>
    isNavItemActive(location.pathname, tab.to, true)
  )
  if (!activeTab) {
    return null
  }

  return (
    <Tabs
      value={activeTab.to}
      aria-label={`${item.label} sections`}
      sx={{ mb: 2, minHeight: 40, borderBottom: 1, borderColor: "divider" }}
    >
      {item.tabs.map((tab) => (
        <Tab
          key={tab.to}
          value={tab.to}
          label={tab.label}
          component={RouterLink}
          to={tab.to}
          sx={{ minHeight: 40, textTransform: "none", fontWeight: 600 }}
        />
      ))}
    </Tabs>
  )
}
